<template>
  <div class="flex flex-row items-center gap-2">
    <WellIcon icon="hourglass-01" />
    <span>{{ formatDuration(duration) }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import WellIcon from '@/components/common/WellIcon.vue'

const props = defineProps<{
  duration: number
}>()

const formatDuration = (duration: number) => {
  const hours = Math.floor(duration / 60)
  const minutes = duration % 60
  
  if (hours === 0) {
    return `${minutes}m`
  } else if (minutes === 0) {
    return hours > 1 ? `${hours}h` : `${hours} hour`
  } else {
    return `${hours}h ${minutes}m`
  }
}

</script>
